// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  position: relative;
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.ex-input {
  flex: auto;
}
.ex-input.offset-left {
  padding-left: 55px;
}

.fill-ex-toggle-default,
.fill-ex-toggle-slider {
  position: relative;
  top: -5px;
}

.fill-ex-toggle-default {
  width: 80px;
}

.fill-ex-toggle-slider {
  width: 55px;
}

.outline-ex-toggle-combined-slider,
.fill-ex-toggle-combined-slider {
  position: absolute;
  display: grid;
  top: 0;
  left: 0;
  height: 100%;
  width: 55px;
  align-content: center;
  justify-content: center;
  background-color: var(--color-theme-primary, #244e91);
}
.outline-ex-toggle-combined-slider.ex-toggle-disabled,
.fill-ex-toggle-combined-slider.ex-toggle-disabled {
  background-color: #777777;
}
.outline-ex-toggle-combined-slider .mat-mdc-slide-toggle,
.fill-ex-toggle-combined-slider .mat-mdc-slide-toggle {
  --mdc-switch-selected-icon-color: var(--color-theme-primary, #244e91);
  --mdc-switch-selected-handle-color: white;
  --mdc-switch-selected-pressed-handle-color: white;
  --mdc-switch-selected-pressed-state-layer-color: white;
  --mdc-switch-selected-hover-handle-color: #ebebeb;
  --mdc-switch-selected-focus-handle-color: #ebebeb;
  --mdc-switch-selected-track-color: #e0e0e0;
  --mdc-switch-selected-pressed-track-color: #e0e0e0;
  --mdc-switch-selected-hover-track-color: #e0e0e0;
  --mdc-switch-selected-focus-track-color: #e0e0e0;
}

.outline-ex-toggle-combined-slider {
  border-radius: 4px 0 0 4px;
}

.fill-ex-toggle-combined-slider {
  border-radius: 4px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/text-input-ex/text-input-ex.component.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;AAII;EACI,kBAZK;AAUb;;AAMA;;EAEI,kBAAA;EACA,SAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,WA3BS;AAwBb;;AAMA;;EAEI,kBAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,qDAAA;AAHJ;AAII;;EACI,yBAAA;AADR;AAGI;;EACI,qEAAA;EACA,yCAAA;EACA,iDAAA;EACA,sDAAA;EACA,iDAAA;EACA,iDAAA;EACA,0CAAA;EACA,kDAAA;EACA,gDAAA;EACA,gDAAA;AAAR;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,wBAAA;AADJ","sourcesContent":["@use './../../../scss/theme';\n\n$sliderSize: 55px;\n\n.root {\n    position: relative;\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n}\n\n.ex-input {\n    flex: auto;\n    &.offset-left {\n        padding-left: $sliderSize;\n    }\n}\n\n.fill-ex-toggle-default,\n.fill-ex-toggle-slider {\n    position: relative;\n    top: -5px;\n}\n\n.fill-ex-toggle-default {\n    width: 80px;\n}\n\n.fill-ex-toggle-slider {\n    width: $sliderSize;\n}\n\n.outline-ex-toggle-combined-slider,\n.fill-ex-toggle-combined-slider {\n    position: absolute;\n    display: grid;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 55px;\n    align-content: center;\n    justify-content: center;\n    background-color: theme.theme-color('primary');\n    &.ex-toggle-disabled {\n        background-color: #777777;\n    }\n    & .mat-mdc-slide-toggle {\n        --mdc-switch-selected-icon-color: #{theme.theme-color('primary')};\n        --mdc-switch-selected-handle-color: white;\n        --mdc-switch-selected-pressed-handle-color: white;\n        --mdc-switch-selected-pressed-state-layer-color: white;\n        --mdc-switch-selected-hover-handle-color: #ebebeb;\n        --mdc-switch-selected-focus-handle-color: #ebebeb;\n        --mdc-switch-selected-track-color: #e0e0e0;\n        --mdc-switch-selected-pressed-track-color: #e0e0e0;\n        --mdc-switch-selected-hover-track-color: #e0e0e0;\n        --mdc-switch-selected-focus-track-color: #e0e0e0;\n    }\n}\n\n.outline-ex-toggle-combined-slider {\n    border-radius: 4px 0 0 4px;\n}\n\n.fill-ex-toggle-combined-slider {\n    border-radius: 4px 0 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
